/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */

import React, { useContext, useEffect } from "react";
import { UmbracoContext } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import Carousel from "react-material-ui-carousel";
import MySpinner from "../../../components/Spinner";
//import imgPleaseWait from "./calculation_Gif.gif";
import "./PleaseWait.scss";
import { Row, Line } from "meitav-uikit";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const { UmbracoUtills } = utils;

const Item = (props) => (
  <div className="itemCarousel">
    <div className="itemCarouselDescription">
      {UmbracoUtills.getParsedHtmlValueByKey(
        props.item.properties,
        "description"
      )}
    </div>
  </div>
);

export default function PleaseWaitInner() {
  useEffect(() => {
    redirect();
  }, []);

  const redirect = () => {
    window.dataLayer.push({
      event: "PM - needs",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "חישוב תיק ההשקעות",
        action_name: "המתנה לחישוב תיק ההשעות",
      },
    });
    const time =
      UmbracoUtills.getParsedHtmlValueByKey(resource, "reidircetAfterSec") *
      1000;
    // const time =1000 * 1000;
    sleep(time).then(
      () =>
      (window.location.href = UmbracoUtills.getParsedHtmlValueByKey(
        resource,
        "redirectToPath"
      ))
    );
  };
  const resource = useContext(UmbracoContext).resource.properties;
  const items = useContext(UmbracoContext).resource.children[0]?.children;
  return (
    <div className="PleaseWaitInner">
      <Row role="alert" id="container">
        <Line className="imgWrapper">
          {/* <img src={imgPleaseWait} /> */}
          <MySpinner
            styleObj={{ position: "relative" }}
            isHideText={true}
          />
        </Line>
        <Line>
          <div className="title">
            {UmbracoUtills.getParsedHtmlValueByKey(resource, "title")}
          </div>
        </Line>
        <Line>
          <div className="subTitle">
            {UmbracoUtills.getParsedHtmlValueByKey(resource, "subTitle")}
          </div>
        </Line>
      </Row>
      <Carousel
          navButtonsAlwaysInvisible
          activeIndicatorIconButtonProps={{
            style: {
              color: "#afafaf"
            },
          }}
          indicatorIconButtonProps={{
            style: {
              transition: '200ms',
            }
          }}
          >
          {items.map((item, i) => (
            <Item key={i} item={item} />
          ))}
        </Carousel>
    </div>
  );
}
